"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabBarItem = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const react_1 = __importDefault(require("react"));
const StyledTabBarItem = components_core_1.styled.div `
  display: inline-flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;
  justify-content: flex-end;
  cursor: ${props => props.hasClickHandler && 'pointer'};
  border-bottom: ${props => props.active
    ? `2px solid ${props.theme.colors.tab.default}`
    : props.active === false
        ? `2px solid transparent`
        : 'none'};
  padding-bottom: ${props => props.withoutPagination
    ? props.theme.size.static300
    : props.theme.size.static200};
`;
const HeadlineWrapper = components_core_1.styled.div `
  text-align: center;
  color: ${props => props.theme.colors.tab.default};
`;
const PriceWrapper = components_core_1.styled.div `
  text-align: center;
  margin-top: ${props => props.theme.size.static200};
`;
function TabBarItem({ headline, price, active, onClick, withoutPagination }) {
    return (react_1.default.createElement(StyledTabBarItem, { "data-testid": "tabBarItem", onClick: onClick, hasClickHandler: Boolean(onClick), active: active, withoutPagination: withoutPagination, className: "tab-bar-item-container" },
        react_1.default.createElement(HeadlineWrapper, { className: "headline-wrapper" }, headline),
        price && react_1.default.createElement(PriceWrapper, { className: "price-wrapper" }, price)));
}
exports.TabBarItem = TabBarItem;
